import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout/Layout';
import { Home } from './pages/Home';
import { Gallery } from './pages/Gallery';
import { About } from './pages/About';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Contact } from './pages/Contact';
import { Toolkits } from './pages/Toolkits';
import { NetworkingGuide } from './pages/NetworkingGuide';
import { FAQ } from './pages/FAQ';
import { Partners } from './pages/Partners';
import { Events } from './pages/Events';
import { SuccessStories } from './pages/SuccessStories';
import { PartnerWithUs } from './pages/PartnerWithUs';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { CookiePolicy } from './pages/CookiePolicy';
import { Portfolio } from './pages/Portfolio';
import { Membership } from './pages/Membership';
import { JoinTeam } from './pages/JoinTeam';
import { JoinNow } from './pages/JoinNow';
import { InnerCircle } from './pages/InnerCircle';
import { LifetimePartner } from './pages/LifetimePartner';
import { WaitingRoom } from './pages/WaitingRoom';
import { WarriEvent2025 } from './pages/WarriEvent2025';
import { HowToEngage } from './pages/HowToEngage';
import { HostSalon } from './pages/HostSalon';
import { Spotlight } from './pages/Spotlight';
import { BibiEnejeSpotlight } from './pages/BibiEnejeSpotlight';
import { SalonSpotlight } from './pages/SalonSpotlight';
import { Team } from './pages/Team';
import { TeamMemberDetail } from './pages/TeamMemberDetail';
import { Dialog } from './components/UI/Dialog';
import { HostSalonDialog } from './components/UI/HostSalonDialog';
import { PaymentDialog } from './components/UI/PaymentDialog';
import { CorporateTrainingDialog } from './components/UI/CorporateTrainingDialog';
import './index.css';
export function App() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isHostFormOpen, setIsHostFormOpen] = useState(false);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [isCorporateTrainingOpen, setIsCorporateTrainingOpen] = useState(false);
  const openRegistrationForm = () => {
    setIsFormOpen(true);
  };
  const openHostSalonForm = () => {
    setIsHostFormOpen(true);
  };
  const openPaymentForm = () => {
    setIsPaymentOpen(true);
  };
  const openCorporateTrainingForm = () => {
    setIsCorporateTrainingOpen(true);
  };
  useEffect(() => {
    window.openRegistrationForm = openRegistrationForm;
    window.openHostSalonForm = openHostSalonForm;
    window.openPaymentForm = openPaymentForm;
    window.openCorporateTrainingForm = openCorporateTrainingForm;
    return () => {
      delete window.openRegistrationForm;
      delete window.openHostSalonForm;
      delete window.openPaymentForm;
      delete window.openCorporateTrainingForm;
    };
  }, []);
  return <Router data-id="element-0">
      <Layout openRegistrationForm={openRegistrationForm} openHostSalonForm={openHostSalonForm} openPaymentForm={openPaymentForm} data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home openRegistrationForm={openRegistrationForm} openHostSalonForm={openHostSalonForm} openPaymentForm={openPaymentForm} data-id="element-4" />} data-id="element-3" />
          <Route path="/gallery" element={<Gallery data-id="element-6" />} data-id="element-5" />
          <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
          <Route path="/team" element={<Team data-id="element-10" />} data-id="element-9" />
          <Route path="/team/:id" element={<TeamMemberDetail data-id="element-12" />} data-id="element-11" />
          <Route path="/blog" element={<Blog data-id="element-14" />} data-id="element-13" />
          <Route path="/blog/:slug" element={<BlogPost data-id="element-16" />} data-id="element-15" />
          <Route path="/contact" element={<Contact data-id="element-18" />} data-id="element-17" />
          <Route path="/toolkits" element={<Toolkits data-id="element-20" />} data-id="element-19" />
          <Route path="/networking-guide" element={<NetworkingGuide data-id="element-22" />} data-id="element-21" />
          <Route path="/faq" element={<FAQ openRegistrationForm={openRegistrationForm} data-id="element-24" />} data-id="element-23" />
          <Route path="/partners" element={<Partners data-id="element-26" />} data-id="element-25" />
          <Route path="/events" element={<Events data-id="element-28" />} data-id="element-27" />
          <Route path="/events/warri-2025" element={<WarriEvent2025 data-id="element-30" />} data-id="element-29" />
          <Route path="/success-stories" element={<SuccessStories data-id="element-32" />} data-id="element-31" />
          <Route path="/portfolio" element={<Portfolio data-id="element-34" />} data-id="element-33" />
          <Route path="/membership" element={<Membership data-id="element-36" />} data-id="element-35" />
          <Route path="/join-team" element={<JoinTeam data-id="element-38" />} data-id="element-37" />
          <Route path="/joinnow" element={<JoinNow data-id="element-40" />} data-id="element-39" />
          <Route path="/inner-circle" element={<InnerCircle data-id="element-42" />} data-id="element-41" />
          <Route path="/lifetime-partner" element={<LifetimePartner data-id="element-44" />} data-id="element-43" />
          <Route path="/waiting-room" element={<WaitingRoom data-id="element-46" />} data-id="element-45" />
          <Route path="/join-the-salon" element={<HowToEngage data-id="element-48" />} data-id="element-47" />
          <Route path="/host-salon" element={<HostSalon data-id="element-50" />} data-id="element-49" />
          <Route path="/spotlight" element={<Spotlight data-id="element-52" />} data-id="element-51" />
          <Route path="/salon-spotlight" element={<SalonSpotlight data-id="element-54" />} data-id="element-53" />
          <Route path="/spotlight/bibi-eneje" element={<BibiEnejeSpotlight data-id="element-56" />} data-id="element-55" />
          <Route path="/partner-with-us" element={<PartnerWithUs openRegistrationForm={openRegistrationForm} openHostSalonForm={openHostSalonForm} data-id="element-58" />} data-id="element-57" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-60" />} data-id="element-59" />
          <Route path="/terms-of-service" element={<TermsOfService data-id="element-62" />} data-id="element-61" />
          <Route path="/cookie-policy" element={<CookiePolicy data-id="element-64" />} data-id="element-63" />
        </Routes>
      </Layout>
      <Dialog isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} title="Join the Salon" size="xl" data-id="element-65">
        <div className="w-full" data-id="element-66">
          <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdr_5jvYO4hJncEC0hjHQweFJSh8FFpzrBhsjQvCQemuZT7MA/viewform?embedded=true" width="100%" height="600" frameBorder="0" marginHeight={0} marginWidth={0} data-id="element-67">
            Loading…
          </iframe>
        </div>
      </Dialog>
      <HostSalonDialog isOpen={isHostFormOpen} onClose={() => setIsHostFormOpen(false)} data-id="element-68" />
      <PaymentDialog isOpen={isPaymentOpen} onClose={() => setIsPaymentOpen(false)} data-id="element-69" />
      <CorporateTrainingDialog isOpen={isCorporateTrainingOpen} onClose={() => setIsCorporateTrainingOpen(false)} data-id="element-70" />
    </Router>;
}